import {FormControl, FormField, RadioOption} from 'platform/components';
import {Heading, Show, VStack} from 'platform/foundation';

import {UseFormReturn, useWatch} from 'react-hook-form';

import {useGetBranchListQuery} from '@dms/api/core';
import i18n from '@dms/i18n';
import {getOptionsFromBranches} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {OverviewForm} from '../types/OverviewForm';

interface BranchScopeProps extends RequiredTestIdProps {
  control: FormControl<OverviewForm>;
  formApi: UseFormReturn<OverviewForm>;
}

export function BranchScope(props: BranchScopeProps) {
  const branchScope = useWatch({control: props.control, name: 'articlesScope.branchScope'});

  const branchesQuery = useGetBranchListQuery();

  const handleBranchScopeChange = (value: string | null) => {
    if (value === SELECT) {
      props.formApi.setValue('articlesScope.branchScope.articleScopeBranchAll', false);
      return;
    }

    props.formApi.setValue('articlesScope.branchScope.articleScopeBranchAll', true);
    props.formApi.setValue('articlesScope.branchScope.articleScopeBranches', null);
  };

  return (
    <VStack spacing={4}>
      <Heading size={5}>{i18n.t('entity.warehouse.labels.branch')}</Heading>
      <FormField
        control={props.control}
        type="radio"
        name="articlesScope.branchScope.option"
        options={options}
        onChange={handleBranchScopeChange}
        direction="column"
        spacing={4}
        data-testid={suffixTestId('inputs.branchScope', props)}
      />
      <Show when={branchScope.option === SELECT}>
        <FormField
          isLoading={branchesQuery.isLoading}
          control={props.control}
          type="multiChoice"
          name="articlesScope.branchScope.articleScopeBranches"
          options={getOptionsFromBranches(branchesQuery.data)}
          data-testid={suffixTestId('inputs.selectedBranch', props)}
        />
      </Show>
    </VStack>
  );
}

const ALL = 'all';
const SELECT = 'select';

const options: RadioOption[] = [
  {
    label: i18n.t('entity.warehouse.labels.enableForAllBranches'),
    value: ALL,
  },
  {
    label: i18n.t('entity.warehouse.labels.selectBranch'),
    value: SELECT,
  },
];
